define(["exports", "hyperhtml", "./pubsubhub"], function (_exports, _hyperhtml, _pubsubhub) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["<a href=\"", "\">Req. ", "</a>"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  const name = "core/requirements";
  _exports.name = name;

  function run() {
    document.querySelectorAll(".req").forEach((req, i) => {
      const frag = "#".concat(req.getAttribute("id"));
      const el = (0, _hyperhtml.default)(_templateObject(), frag, i + 1);
      req.prepend(el, ": ");
    });
    document.querySelectorAll("a.reqRef[href]").forEach(ref => {
      const href = ref.getAttribute("href");
      const id = href.substring(1); // href looks like `#id`

      const req = document.getElementById(id);
      let txt;

      if (req) {
        txt = req.querySelector("a:first-child").textContent;
      } else {
        txt = "Req. not found '".concat(id, "'");
        const msg = "Requirement not found in element `a.reqRef`: ".concat(id);
        (0, _pubsubhub.pub)("error", msg);
        console.warn(msg, ref);
      }

      ref.textContent = txt;
    });
  }
});
//# sourceMappingURL=requirements.js.map